var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.356,
    height: 17.235,
    viewBox: "0 0 16.356 17.235",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Light_Home",
    "data-name": "Iconly/Light/Home",
    transform: "translate(-1.333 -0.819)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home",
    transform: "translate(2.083 1.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Home-2",
    "data-name": "Home",
    d: "M5.205,14.677v-2.4a1.115,1.115,0,0,1,1.113-1.11H8.575A1.115,1.115,0,0,1,9.7,12.279h0v2.405a.958.958,0,0,0,.94.953h1.5a2.7,2.7,0,0,0,2.715-2.688h0V6.128A1.907,1.907,0,0,0,14.1,4.639L8.959.536a2.487,2.487,0,0,0-3.084,0L.752,4.646A1.893,1.893,0,0,0,0,6.136v6.814a2.7,2.7,0,0,0,2.715,2.688h1.5a.966.966,0,0,0,.97-.961h0",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.1682f06a1bc3b811e7882fa139036c97.svg";
export { ForwardRef as ReactComponent };